import { Injectable } from '@angular/core';

@Injectable()
export class AjaxLoaderService
{
    private _selector = 'ajax-loader';
    private _element: HTMLElement;

    constructor()
    {
        this._element = document.getElementById(this._selector);
    }

    public show(): void
    {
        if (this._element)
            this._element.style['display'] = 'flex';
    }

    public hide(delay = 300): void
    {
        if (this._element)
        {
            setTimeout(() =>
            {
                this._element.style['display'] = 'none';
            }, delay);
        }
    }
}
